export function formatPrice(price:number|string=0){
    return (+Math.ceil(+(100 * +(price ?? 0)).toFixed(2)) / 100).toFixed(2);
};

export function formatTotalPrice(price:number|string=0, quantity:number|string=0){
    return ((+(100 * +(formatPrice(price) ?? 0)) * +(quantity ?? 0))/100).toFixed(2);
};

export function formatPriceAsString(price:number|string=0){
    const val = parseFloat(price.toString());
    const options = {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };
    return new Intl.NumberFormat('en-US', options).format(val);
}